export class EntityConflictError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, EntityConflictError.prototype);
    }
}